@if (races().length) {
  <div class="border-t border-slate-200 dark:border-slate-700 mt-7 pt-6">
    <h3 class="text-lg font-black">{{ text('Statistiques des coureurs', 'Runner statistics') }}</h3>
    <p class="text-sm text-slate-500 dark:text-slate-400 mt-2">
      {{
        text(
          'Estimations des membres, par épreuve. Chaque moyenne utilise uniquement les réponses renseignées.',
          'Member estimates, per race. Each average uses only completed answers.'
        )
      }}
    </p>
    <label class="block font-bold text-sm mt-4" for="contribution-race">{{
      text('Épreuve concernée', 'Race')
    }}</label>
    <select
      id="contribution-race"
      class="field mt-2 w-full md:w-auto"
      [ngModel]="selected()"
      (ngModelChange)="selected.set($event)"
      [disabled]="saving()"
    >
      @for (race of races(); track race.id) {
        <option [value]="race.id">{{ race.name }} · {{ race.distance }}</option>
      }
    </select>
    @if (loading()) {
      <p role="status" class="mt-4">
        {{ text('Chargement des contributions…', 'Loading contributions…') }}
      </p>
    } @else if (averages()['total'] != null) {
      <p class="text-sm mt-4">
        {{ averages()['total'] || 0 }}
        {{ text('contribution(s) pour cette épreuve', 'contribution(s) for this race') }}
      </p>
      <dl class="grid grid-cols-2 lg:grid-cols-4 gap-4 my-4">
        @for (field of fields; track field.key) {
          <div class="accent-surface rounded-2xl border p-4">
            <dt class="text-sm font-bold">{{ text(field.fr, field.en) }}</dt>
            <dd class="text-2xl font-black mt-2 text-slate-900 dark:text-white">
              {{ averages()[field.key] == null ? '—' : (averages()[field.key] | number: '1.0-2') }}
              <span class="text-sm">{{ field.unit }}</span>
            </dd>
            <dd class="text-xs text-slate-500 dark:text-slate-400 mt-2">
              {{ averages()[field.key + '_count'] || 0 }} {{ text('réponse(s)', 'answer(s)') }}
            </dd>
          </div>
        }
      </dl>
      @if (!error() && !averages()['total']) {
        <p class="text-sm mb-4">
          {{
            text(
              'Aucune contribution pour le moment. Soyez le premier à partager vos mesures !',
              'No contributions yet. Be the first to share your measurements!'
            )
          }}
        </p>
      }
    }
    @if (registered()) {
      <details class="rounded-xl border border-slate-200 dark:border-slate-700 p-4 mt-4">
        <summary class="cursor-pointer font-bold">
          {{
            existing()
              ? text('Modifier ma contribution', 'Edit my contribution')
              : text('Donner mes statistiques', 'Share my statistics')
          }}
        </summary>
        <p class="text-sm text-slate-500 dark:text-slate-400 my-3">
          {{
            text(
              'Partagez les données de votre parcours. Champs facultatifs ; une réponse par membre et par épreuve, modifiable. Les réponses individuelles ne sont pas publiques.',
              'Share your course data. Optional fields; one editable response per member per race. Individual responses are not public.'
            )
          }}
        </p>
        <form #form="ngForm" (ngSubmit)="form.valid && save()">
          <fieldset
            [disabled]="loading() || saving() || averages()['total'] == null"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
          >
            @for (field of fields; track field.key) {
              <label class="text-sm font-bold"
                >{{ text(field.fr, field.en) }} ({{ field.unit }})
                @if (field.key === 'difficulty' || field.key === 'waymarking') {
                  <select
                    class="field mt-2"
                    [name]="field.key"
                    [(ngModel)]="answers[field.key]"
                  >
                    <option [ngValue]="null">{{ text('Non renseigné', 'Not provided') }}</option>
                    @for (score of [1, 2, 3, 4, 5]; track score) {
                      <option [ngValue]="score">{{ score }} / 5</option>
                    }
                  </select>
                  <span class="block text-xs font-normal mt-2 text-slate-500 dark:text-slate-400">{{
                    field.key === 'difficulty'
                      ? text('1 : facile · 5 : très difficile', '1: easy · 5: very difficult')
                      : text('1 : insuffisant · 5 : excellent', '1: poor · 5: excellent')
                  }}</span>
                } @else {
                  <input
                    type="number"
                    class="field mt-2"
                    [name]="field.key"
                    [(ngModel)]="answers[field.key]"
                    [min]="field.min"
                    [max]="field.max"
                    [step]="field.step"
                    [placeholder]="field.key === 'elevation_gain_m' ? '75' : '5,2'"
                  />
                }
              </label>
            }
          </fieldset>
          <div class="flex flex-wrap gap-3 mt-4">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="!form.valid || loading() || saving() || averages()['total'] == null"
            >
              {{
                saving()
                  ? text('Enregistrement…', 'Saving…')
                  : text('Enregistrer ma contribution', 'Save my contribution')
              }}
            </button>
            @if (existing()) {
              <button
                type="button"
                (click)="save(true)"
                [disabled]="loading() || saving()"
                class="px-4 py-2 rounded-xl border border-slate-300 dark:border-slate-600"
              >
                {{ text('Retirer ma contribution', 'Remove my contribution') }}
              </button>
            }
          </div>
        </form>
      </details>
    } @else {
      <p class="text-sm mt-4">
        <a routerLink="/login" class="link-accent underline">{{
          text('Connectez-vous', 'Sign in')
        }}</a>
        {{
          text(
            'avec votre compte membre pour contribuer.',
            'with your member account to contribute.'
          )
        }}
      </p>
    }
    @if (error()) {
      <p role="alert" class="text-red-600 mt-3">
        {{ error() }}
        <button type="button" class="underline" (click)="retry()" [disabled]="saving()">
          {{ text('Recharger', 'Reload') }}
        </button>
      </p>
    }
    @if (message()) {
      <p role="status" class="text-green-600 mt-3">{{ message() }}</p>
    }
  </div>
}
